
export type GetCourseDraftCount200 = {
  /**
   * 코스 초안 개수
   * @minimum 0
   */
  count: number;
};
